import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Radio,
  AvatarGroup,
  Avatar,
  Pagination,
  Modal,
  createTheme,
  ThemeProvider,
  CircularProgress,
  IconButton,
  TextField,
  InputProps,
  InputAdornment,
} from "@mui/material";
import "@fontsource/manrope";
import SearchIcon from "@mui/icons-material/Search";
import { getAllProjects } from "../../services/webServices";
import { useLocation } from "react-router-dom";
import Epics from "./Epics.js";
import BugReportFiltersPage from "./BugReportFiltersPage.js";
import CloseIcon from "@mui/icons-material/Close";

const theme = createTheme({
  typography: {
    fontFamily: "Manrope, Arial, sans-serif",
  },
});

const JiraProjectsComponentPage = ({
  taskType,
  issueType,
  projectsLoading,
  setOpenProjectPage,
  projectsList,
  selectedProject,
  setSelectedProject,
}) => {
  const [page, setPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleRadioChange = (project) => {
    setSelectedProject(project);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleCloseModal = () => {
    setOpenProjectPage(false);
    setIsModalOpen(false);
  };

  const projectsPerPage = 6;
  const filteredProjects = projectsList.filter((project) =>
    project.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const displayedProjects = filteredProjects.slice(
    (page - 1) * projectsPerPage,
    page * projectsPerPage
  );

  return (
    <>
      <ThemeProvider theme={theme}>
        <Modal
          open={isModalOpen}
          onClose={handleCloseModal}
          aria-labelledby="import-bug-description-title"
          aria-describedby="import-bug-description-instructions"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "550px",
              height: "500px",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              outline: "none",
            }}
          >
            <IconButton
              onClick={handleCloseModal}
              sx={{
                position: "absolute",
                top: "8px",
                right: "8px",
              }}
            >
              <CloseIcon />
            </IconButton>
            <Typography
              id="import-bug-description-title"
              variant="h6"
              sx={{ textAlign: "left", mb: 2 }}
            >
              {taskType.substring(0, 1).toUpperCase() + taskType.substring(1)} {issueType}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography
                id="import-bug-description-instructions"
                variant="subtitle2"
                sx={{ textAlign: "left", color: "text.secondary" }}
              >
                Select a project to move forward
              </Typography>
              <TextField
                size="small"
                placeholder="Search projects"
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPage(1);
                }}
                sx={{ width: "200px", ml: 2 }}
                InputProps={{
                  endAdornment: (
                    <SearchIcon
                      sx={{ color: "#888", cursor: "pointer" }}
                    />
                  ),
                }}
              />
            </Box>

            {!(projectsList.length > 0) && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute", // Absolute positioning
                  top: "50%", // Center vertically
                  left: "50%", // Center horizontally
                  transform: "translate(-50%, -50%)", // Adjusts the position to exact center
                  width: "100%", // Ensures full width for alignment
                }}
              >
                {projectsLoading ? (
                  <CircularProgress />
                ) : (
                  <Typography>No Projects found</Typography>
                )}
              </Box>
            )}

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: 1.5,
                flex: 1,
                overflowY: "auto",
              }}
            >
              {displayedProjects.map((project, index) => {
                const maxAvatars = 5;
                // const displayedMembers = project.teamMembers.slice(
                //   0,
                //   maxAvatars
                // );
                // const remainingCount = project.teamMembers.length - maxAvatars;

                return (
                  <Card
                    key={index}
                    variant="outlined"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "250px",
                      height: "90px",
                      p: 1,
                      borderRadius: 2,
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        ml: -1,
                      }}
                    >
                      <Radio
                        checked={selectedProject?.id === project.id}
                        onChange={() => handleRadioChange(project)}
                        value={project}
                        name="project-radio"
                        inputProps={{ "aria-label": project.name }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          textAlign: "left",
                        }}
                      >
                        {project.name}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mt: -1,
                      }}
                    >
                      <AvatarGroup
                        max={5}
                        sx={{
                          justifyContent: "flex-start",
                        }}
                      >
                        {/* {displayedMembers.map((member, idx) => (
                          <Avatar
                            key={idx}
                            sx={{ width: 24, height: 24, fontSize: "0.8rem" }}
                          >
                            {member[0]}
                          </Avatar>
                        ))} */}
                      </AvatarGroup>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ whiteSpace: "nowrap" }}
                      >
                        {/* {displayedMembers[0]}{" "} */}
                        {/* {remainingCount > 0 ? `+ ${remainingCount} more` : ""} */}
                      </Typography>
                    </Box>

                    {/* {project.latUpdate !== "" && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          alignSelf: "flex-start",
                          textAlign: "left",
                          mt: 0.5,
                          ml: 0.5,
                        }}
                      >
                        Last updated: {project.latUpdate}
                      </Typography>
                    )} */}
                  </Card>
                );
              })}
            </Box>
            <Pagination
              count={Math.ceil(filteredProjects.length / projectsPerPage)}
              page={page}
              onChange={handlePageChange}
              sx={{ mt: 2, display: "flex", justifyContent: "center" }}
            />
          </Box>
        </Modal>
      </ThemeProvider>
    </>
  );
};

export default JiraProjectsComponentPage;